





















import { Component, Prop, Watch, Ref, Vue } from 'vue-property-decorator'
import SignaturePad from 'signature_pad'

/**
 * See signature_pad github for more details.
 * https://github.com/szimek/signature_pad
 */
@Component({
  name: 'SignaturePad',
})
export default class extends Vue {
  signaturePad?: SignaturePad
  isDrawing: boolean = false

  @Ref()
  canvas!: HTMLCanvasElement

  @Prop({ type: String, default: '' })
  id!: string

  @Prop({ type: [Number, Function], default: 0.5 })
  dotSize!: number | (() => number)

  @Prop({ type: Number, default: 0.5 })
  minWidth!: number

  @Prop({ type: Number, default: 2.5 })
  maxWidth!: number

  @Prop({ type: Number, default: 16 })
  throttle!: number

  @Prop({ type: Number, default: 5 })
  minDistance!: number

  @Prop({ type: String, default: 'rgba(0,0,0,0)' })
  backgroundColor!: string

  @Prop({ type: String, default: 'black' })
  penColor!: string

  @Prop({ type: Number, default: 0.7 })
  velocityFilterWeight!: number

  mounted() {
    // Bind functions for callback
    const onBegin = this.onBegin.bind(this)
    const onEnd = this.onEnd.bind(this)

    // Initialize with properties
    this.signaturePad = new SignaturePad(this.canvas, {
      ...this.$props,
      onBegin,
      onEnd,
    })

    this.$root.$on(
      '::signature-pad::clear',
      (id: string) => id === this.id && this.clear()
    )
  }

  beforeDestroy() {
    this.signaturePad && this.signaturePad.off()
    delete this.signaturePad
  }

  clear() {
    this.signaturePad && this.signaturePad.clear()
    this.$emit('input', undefined)
  }

  isEmpty() {
    this.signaturePad && this.signaturePad.isEmpty()
  }

  onBegin() {
    this.isDrawing = true
    this.$emit('begin')
  }

  onEnd() {
    this.isDrawing = false
    this.$emit('end')
    // get the png format data string
    const data = this.signaturePad && this.signaturePad.toDataURL()
    this.$emit('input', data)
  }
}
